import { useAppContext, useSelfContext } from '@/context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useSingleSelfRedirect() {
  const navigate = useNavigate();
  const { mode } = useAppContext();
  const { currentSelf, redirectToSelf, currentSelfItems, selectSelf, redirectToReserve } = useSelfContext();

  useEffect(() => {
    if (currentSelf || currentSelfItems.length !== 1) return;
    const newSelf = currentSelfItems[0];
    selectSelf(newSelf);
    redirectToReserve({ mode, navigate });
  }, [currentSelf, currentSelfItems, mode, navigate, selectSelf, redirectToSelf]);

}

export default useSingleSelfRedirect;